import React from 'react';
import { useContact } from '../../context/ContactContext';
import EscalationContext from './EscalationContext';
import HistoryPanel from './HistoryPanel';
import HandoverCard from './HandoverCard';
import LiveTranscript from './LiveTranscript';
import CallbackTaskCard from './CallbackTaskCard';
import CallbackOriginCard from './CallbackOriginCard';   // #20 (2026-09-23)
import CallerCardV4 from './CallerCardV4';
// v3 design parity (#112, epic #117): the connected-call centre — transcript
// and caller history. The AI handover cards (EscalationContext, HandoverCard)
// are restyled separately, after Storm's live inbound check.
import '../../styles/oncall-v3.css';

// Render order (2026-09-14): the live transcript now sits ABOVE caller history.
// The centre panel is a fixed-height column with overflow hidden and the
// transcript takes the remaining height (flex: 1, min-height in
// live-transcript.css); history used to render before it with no cap, so a
// frequent caller pushed the transcript out of view during a live call. Order
// is now: what this contact is (task card / escalation / handover) → what is
// being said right now (transcript) → what happened before (history, capped
// to three rows with a toggle).
export default function CentrePanel() {
  const { display } = useContact();
  // 2026-09-22 (Storm's live task check): on a TASK contact the transcript
  // panel only ever shows its "voice-only" note, yet it held its 260px floor
  // and squeezed the handover card to its 128px floor, clipping the Contact
  // ID. `is-task` lets oncall-v3.css make it a fixed header-only panel on tasks.
  const isTask = display?.meta?.channel === 'TASK';
  return (
    <main className={`centre-panel oncall-v3-screen${isTask ? ' is-task' : ''}`}>
      {/* Incident 2026-09-14 fix 1: TASK contacts only — says nobody is on
          the line and surfaces the outbound dialer pre-filled from the task. */}
      <CallbackTaskCard />
      {/* #20: a voice leg dialled FOR a callback says so (VOICE only). */}
      <CallbackOriginCard />
      <EscalationContext />
      <HandoverCard />
      {/* Console v4 (row 234, behind ?ui=v4): one caller card replaces the
          pair above, which render nothing while v4 is on (see each file). */}
      <CallerCardV4 />
      <LiveTranscript />
      <HistoryPanel />
    </main>
  );
}
